const popUpWhatsApp = {
  init: function() {
    if (this.hidePopupPage || !this.component)
      return

    this.addEventListeners()
  },

  addEventListeners: function() {
    document.addEventListener("DOMContentLoaded", this.handleDOMContentLoadedEvent.bind(this))
    this.closeModalBtn.addEventListener('click', this.hidePopup.bind(this))
  },

  handleDOMContentLoadedEvent: function() {
    setTimeout(this.showPopup.bind(this), 5000)
    setTimeout(this.hidePopup.bind(this), 13000)
  },

  hidePopup: function() {
    this.component.classList.remove('show-popup')
    this.iconWhats.style.display = 'block'
  },

  
  showPopup: function() {
    const header = document.querySelector('.header-wrapper');
    const headerHeight = header ? header.offsetHeight : 0;

    const popupWrapper = this.component.querySelector('.popup-whatsapp-content__wrapper');
    if (popupWrapper) {
      popupWrapper.style.top = `${headerHeight + 30}px`;
    }

    this.component.classList.add('show-popup');
    this.iconWhats.style.display = 'none';
  },

  closeModalBtn: document.getElementById("close-modal"),
  component: document.getElementById("popup-whatsapp"),
  hidePopupPage: document.querySelector('.hide-popup'),
  iconWhats: document.querySelector('.joinchat')
}

popUpWhatsApp.init()
